export const styles = {
	root: {
		padding: 0,
		marginBottom: '40px'
	},
	buttonSuccess: {
		backgroundColor: 'primary.main',
		'&:hover': {
			backgroundColor: 'primary.main'
		}
	},
	fabProgress: {
		color: 'primary.main',
		position: 'absolute',
		top: '-6px',
		left: '-6px',
		zIndex: 1
	}
};
